/* tslint:disable */
import {
  ChartOfAccount,
  WorkOrder,
  UserProfile,
  VendorPayments
} from '../index';

declare var Object: any;
export interface PropertyBillsInterface {
  "amount": number;
  "description"?: string;
  "date_incurred": Date;
  "date_due": Date;
  "property_id"?: number;
  "property_unit_id"?: number;
  "payment_status"?: string;
  "bill_type"?: string;
  "property_settlement_id"?: number;
  "id"?: number;
  "chart_of_account_id"?: number;
  "vendor_profile_id"?: number;
  "createdAt": Date;
  "updatedAt": Date;
  "deletedAt"?: Date;
  chartOfAccount?: ChartOfAccount;
  workOrder?: WorkOrder;
  vendorProfile?: UserProfile;
  vendorPayments?: VendorPayments[];
}

export class PropertyBills implements PropertyBillsInterface {
  "amount": number;
  "description": string;
  "date_incurred": Date;
  "date_due": Date;
  "property_id": number;
  "property_unit_id": number;
  "payment_status": string;
  "bill_type": string;
  "property_settlement_id": number;
  "id": number;
  "chart_of_account_id": number;
  "vendor_profile_id": number;
  "createdAt": Date;
  "updatedAt": Date;
  "deletedAt": Date;
  chartOfAccount: ChartOfAccount;
  workOrder: WorkOrder;
  vendorProfile: UserProfile;
  vendorPayments: VendorPayments[];
  constructor(data?: PropertyBillsInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `PropertyBills`.
   */
  public static getModelName() {
    return "PropertyBills";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of PropertyBills for dynamic purposes.
  **/
  public static factory(data: PropertyBillsInterface): PropertyBills{
    return new PropertyBills(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'PropertyBills',
      plural: 'PropertyBills',
      path: 'PropertyBills',
      idName: 'id',
      properties: {
        "amount": {
          name: 'amount',
          type: 'number'
        },
        "description": {
          name: 'description',
          type: 'string'
        },
        "date_incurred": {
          name: 'date_incurred',
          type: 'Date'
        },
        "date_due": {
          name: 'date_due',
          type: 'Date'
        },
        "property_id": {
          name: 'property_id',
          type: 'number',
          default: 0
        },
        "property_unit_id": {
          name: 'property_unit_id',
          type: 'number',
          default: 0
        },
        "payment_status": {
          name: 'payment_status',
          type: 'string'
        },
        "bill_type": {
          name: 'bill_type',
          type: 'string'
        },
        "property_settlement_id": {
          name: 'property_settlement_id',
          type: 'number',
          default: 0
        },
        "id": {
          name: 'id',
          type: 'number'
        },
        "chart_of_account_id": {
          name: 'chart_of_account_id',
          type: 'number'
        },
        "vendor_profile_id": {
          name: 'vendor_profile_id',
          type: 'number'
        },
        "createdAt": {
          name: 'createdAt',
          type: 'Date'
        },
        "updatedAt": {
          name: 'updatedAt',
          type: 'Date'
        },
        "deletedAt": {
          name: 'deletedAt',
          type: 'Date',
          default: new Date(0)
        },
      },
      relations: {
        chartOfAccount: {
          name: 'chartOfAccount',
          type: 'ChartOfAccount',
          model: 'ChartOfAccount',
          relationType: 'belongsTo',
                  keyFrom: 'chart_of_account_id',
          keyTo: 'id'
        },
        workOrder: {
          name: 'workOrder',
          type: 'WorkOrder',
          model: 'WorkOrder',
          relationType: 'hasOne',
                  keyFrom: 'id',
          keyTo: 'propertyBillsId'
        },
        vendorProfile: {
          name: 'vendorProfile',
          type: 'UserProfile',
          model: 'UserProfile',
          relationType: 'belongsTo',
                  keyFrom: 'vendor_profile_id',
          keyTo: 'id'
        },
        vendorPayments: {
          name: 'vendorPayments',
          type: 'VendorPayments[]',
          model: 'VendorPayments',
          relationType: 'hasMany',
                  keyFrom: 'id',
          keyTo: 'propertyBillsId'
        },
      }
    }
  }
}
